import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d80fac38"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "more_vert", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fr_button = _resolveComponent("fr-button")!

  return (_openBlock(), _createElementBlock("div", {
    id: `message-${_ctx.message.id}`,
    class: _normalizeClass(["message w-full flex py-4", { 'justify-end': _ctx.sender }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["message-inner flex w-4/6 md:w-2/5 items-center", {
        'flex-row-reverse': _ctx.sender,
        'justify-center': _ctx.message.sender == 'SYSTEM'
      }])
    }, [
      _createElementVNode("img", {
        src: _ctx.message.senderImageUrl,
        alt: "",
        width: "40",
        height: "40",
        class: _normalizeClass(["rounded-full", { 'ml-2': _ctx.sender, 'mr-2': !_ctx.sender }])
      }, null, 10, _hoisted_2),
      _createElementVNode("div", {
        class: _normalizeClass(["p-4 rounded-md shadow-sm text-gray-900 max-w-full break-words", {
          'bg-blue-200': _ctx.sender,
          'bg-yellow-100': _ctx.message.sender != 'SYSTEM' && !_ctx.sender
        }])
      }, [
        _createTextVNode(_toDisplayString(_ctx.message.text) + " ", 1),
        _hoisted_3,
        _createElementVNode("p", {
          class: _normalizeClass(["text-gray-500 text-xs", { 'text-right': _ctx.sender }])
        }, _toDisplayString(_ctx.formatDate(_ctx.message.date)), 3)
      ], 2),
      _createVNode(_component_fr_button, {
        flat: "",
        rounded: "",
        class: _normalizeClass({ 'mr-2': _ctx.sender, 'ml-2': !_ctx.sender })
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["class"]),
      _createElementVNode("div", {
        class: _normalizeClass([{ 'mr-2': _ctx.sender, 'ml-2': !_ctx.sender }, "message-date-tooltip bg-black bg-opacity-30 text-xs px-4 py-2 text-white rounded-full"])
      }, _toDisplayString(_ctx.$date(_ctx.message.date)), 3)
    ], 2)
  ], 10, _hoisted_1))
}